module.exports = __webpack_public_path__ + "static/media/moleworm.b9211e56.webp";